import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/design-kit')({
    head: () => ({
        meta: [
            {
                title: 'Design Kit | Phoebe Admin',
            },
        ],
    }),
});
